<template>
  <div class="cr-page">
    <!-- 顶部子导航 -->
    <div class="sub-nav">
      <a href="#/" class="sub-nav-back">← 返回首页</a>
      <span class="sub-nav-title">云发布</span>
    </div>

    <!-- 头部文案 -->
    <section class="cr-head">
      <div class="cr-head-tag">
        <span class="cr-head-line"></span>
        CLOUD RELEASE
        <span class="cr-head-line"></span>
      </div>
      <h1 class="cr-head-title">云发布</h1>
      <p class="cr-head-desc">供需信息发布与对接，助力展商与采购方高效匹配</p>
    </section>

    <!-- 主体：两栏布局 -->
    <section class="cr-body">
      <!-- 左：发布表单 -->
      <div class="cr-form-card">
        <div class="cr-form-topbar"></div>
        <div class="cr-form-inner">
          <div class="cr-form-icon">📝</div>
          <h2 class="cr-form-title">发布供需信息</h2>
          <p class="cr-form-sub">填写以下信息，快速发布您的供应或需求</p>

          <form class="cr-form" @submit.prevent="submitForm">
            <div class="cr-field">
              <label class="cr-label">供需类型</label>
              <select v-model="form.type" class="cr-select">
                <option value="supply">展商供应</option>
                <option value="demand">采购需求</option>
              </select>
            </div>

            <div class="cr-field">
              <label class="cr-label">供需内容标题 <span class="cr-req">*</span></label>
              <input
                v-model="form.title"
                type="text"
                class="cr-input"
                placeholder="请输入标题"
              />
            </div>

            <div class="cr-field">
              <label class="cr-label">供需内容详情 <span class="cr-req">*</span></label>
              <textarea
                v-model="form.content"
                class="cr-textarea"
                rows="5"
                placeholder="请详细描述供应或需求信息"
              ></textarea>
            </div>

            <div class="cr-field">
              <label class="cr-label">联系人 <span class="cr-req">*</span></label>
              <input
                v-model="form.contact"
                type="text"
                class="cr-input"
                placeholder="请输入联系人姓名"
              />
            </div>

            <button type="submit" class="cr-submit">发布供需</button>
          </form>
        </div>
      </div>

      <!-- 右：Tab+列表 -->
      <div class="cr-right">
        <div class="cr-tabs">
          <div
            v-for="tab in tabs"
            :key="tab.key"
            class="cr-tab"
            :class="{ active: activeTab === tab.key }"
            @click="activeTab = tab.key"
          >{{ tab.label }}</div>
        </div>

        <div class="cr-list">
          <div
            v-for="item in filteredList"
            :key="item.id"
            class="cr-item"
          >
            <div class="cr-item-head">
              <div class="cr-item-type" :class="item.type">
                {{ item.type === 'supply' ? '供应' : '需求' }}
              </div>
              <h3 class="cr-item-title">{{ item.title }}</h3>
            </div>
            <p class="cr-item-body">{{ item.content }}</p>
            <div class="cr-item-divider"></div>
            <div class="cr-item-foot">
              <span class="cr-item-contact">{{ item.contact }}</span>
              <span class="cr-item-time">{{ item.time }}</span>
            </div>
          </div>

          <div v-if="filteredList.length === 0" class="cr-empty">
            暂无{{ activeTab === 'supply' ? '供应' : activeTab === 'demand' ? '需求' : '' }}信息
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CloudReleaseSection',
  data() {
    return {
      activeTab: 'all',
      tabs: [
        { key: 'all', label: '全部' },
        { key: 'supply', label: '展商供应' },
        { key: 'demand', label: '采购需求' },
      ],
      items: [
        {
          id: 1,
          type: 'supply',
          title: '智能陪护机器人批量供应',
          content: '我司研发的智能陪护机器人具备生命体征监测、语音交互、自动巡检、跌倒报警等功能，适用于养老机构及居家场景。现面向展会采购方提供批量供货，支持定制化解决方案，欢迎洽谈合作。',
          contact: '联系人：李经理 138-0551-0001',
          time: '2026-08-20 09:30',
        },
        {
          id: 2,
          type: 'supply',
          title: '适老化康复理疗设备系列供应',
          content: '专业生产适老化康复理疗设备，包括智能康复训练器、关节活动度训练仪、平衡功能检测系统等，产品通过CE及医疗器械认证。可按工程量提供阶梯报价，面向养老机构、康复中心批量供应。',
          contact: '联系人：王总监 139-0551-0002',
          time: '2026-08-21 14:15',
        },
        {
          id: 3,
          type: 'demand',
          title: '求购适老化改造无障碍卫浴设备',
          content: '我单位承接社区居家适老化改造项目，急需采购一批无障碍卫浴设备，包括助浴椅、安全扶手、防滑地垫、智能坐便器等。要求产品通过相关质量认证，有长期合作意向，欢迎供应商联系对接。',
          contact: '联系人：张主任 137-0551-0003',
          time: '2026-08-22 10:45',
        }
      ],
      form: {
        type: 'supply',
        title: '',
        content: '',
        contact: ''
      }
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === 'all') return this.items;
      return this.items.filter(i => i.type === this.activeTab);
    }
  },
  methods: {
    submitForm() {
      if (!this.form.title || !this.form.content || !this.form.contact) {
        alert('请填写完整的发布信息');
        return;
      }
      const now = new Date();
      const pad = n => (n < 10 ? '0' + n : n);
      const timeStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
      this.items.unshift({
        id: Date.now(),
        type: this.form.type,
        title: this.form.title,
        content: this.form.content,
        contact: '联系人：' + this.form.contact,
        time: timeStr
      });
      this.form.title = '';
      this.form.content = '';
      this.form.contact = '';
      this.activeTab = 'all';
      alert('发布成功！');
    }
  }
};
</script>

<style scoped>
.cr-page {
  min-height: 100vh;
  background: #FFF4E6;
  padding-bottom: 120px;
}

/* ===== 顶部子导航 ===== */
.sub-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 32px;
  background: #fff;
  border-bottom: 1px solid #F0E3D1;
}
.sub-nav-back {
  font-size: 15px;
  font-weight: 700;
  color: #E27A1D;
  text-decoration: none;
  letter-spacing: 0.5px;
}
.sub-nav-back:hover { opacity: 0.75; }
.sub-nav-title {
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 900;
  color: var(--color-text);
}

/* ===== 头部 ===== */
.cr-head {
  text-align: center;
  padding: 100px 32px 64px;
}
.cr-head-tag {
  display: inline-flex;
  align-items: center;
  gap: 18px;
  color: #D4680A;
  font-family: var(--font-serif);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 5px;
  margin-bottom: 20px;
}
.cr-head-line {
  display: inline-block;
  width: 36px;
  height: 1px;
  background: #E2A770;
}
.cr-head-title {
  font-family: var(--font-serif);
  font-size: clamp(44px, 7vw, 72px);
  font-weight: 900;
  color: #2B2420;
  margin: 0 0 18px;
  line-height: 1.1;
}
.cr-head-desc {
  font-size: 17px;
  line-height: 1.9;
  color: #6B5D54;
  margin: 0;
}

/* ===== 主体两栏 ===== */
.cr-body {
  padding: 0 32px;
  max-width: 1320px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 40px;
  align-items: flex-start;
}

/* ===== 左侧表单卡 ===== */
.cr-form-card {
  position: sticky;
  top: 80px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(237, 123, 26, 0.07);
}
.cr-form-topbar {
  height: 6px;
  background: linear-gradient(90deg, #E27A1D, #F3D410);
}
.cr-form-inner {
  padding: 36px 32px 32px;
}
.cr-form-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #FFE8C4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin: 0 auto 14px;
}
.cr-form-title {
  text-align: center;
  font-family: var(--font-serif);
  font-size: 22px;
  font-weight: 900;
  color: #2B2420;
  margin: 0 0 6px;
}
.cr-form-sub {
  text-align: center;
  font-size: 13px;
  color: #7D7269;
  margin: 0 0 28px;
}

.cr-form { display: flex; flex-direction: column; gap: 18px; }
.cr-field { display: flex; flex-direction: column; gap: 8px; }
.cr-label {
  font-size: 14px;
  font-weight: 700;
  color: #3A322C;
}
.cr-req { color: #D14A1C; margin-left: 2px; }

.cr-select,
.cr-input,
.cr-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px;
  background: #fff;
  border: 1px solid #E5D7C4;
  border-radius: 8px;
  font-size: 14px;
  color: #2B2420;
  font-family: inherit;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
}
.cr-select:focus,
.cr-input:focus,
.cr-textarea:focus {
  border-color: #E27A1D;
  box-shadow: 0 0 0 3px rgba(226, 122, 29, 0.12);
}
.cr-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23C85C1B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  cursor: pointer;
}
.cr-textarea { resize: vertical; min-height: 100px; }

.cr-submit {
  margin-top: 8px;
  width: 100%;
  padding: 14px 20px;
  background: linear-gradient(135deg, #E27A1D, #D15F16);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  letter-spacing: 1px;
  box-shadow: 0 8px 20px rgba(194, 90, 45, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.cr-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(194, 90, 45, 0.38);
}

/* ===== 右侧Tab + 列表 ===== */
.cr-right { min-width: 0; }
.cr-tabs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}
.cr-tab {
  padding: 10px 22px;
  background: #fff;
  border: 1px solid #E5D7C4;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: #6B5D54;
  cursor: pointer;
  transition: all 0.25s ease;
  user-select: none;
}
.cr-tab:hover {
  border-color: #E27A1D;
  color: #C25A2D;
}
.cr-tab.active {
  background: linear-gradient(135deg, #E27A1D, #D15F16);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 6px 18px rgba(226, 122, 29, 0.32);
}

.cr-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.cr-item {
  background: #fff;
  border: 1px solid #F0E3D1;
  border-radius: 12px;
  padding: 24px 28px;
  transition: all 0.25s ease;
}
.cr-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(237, 123, 26, 0.08);
  border-color: #F2C794;
}
.cr-item-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.cr-item-type {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #fff;
}
.cr-item-type.supply {
  background: linear-gradient(135deg, #E27A1D, #D15F16);
}
.cr-item-type.demand {
  background: linear-gradient(135deg, #3B82C8, #2868A8);
}
.cr-item-title {
  margin: 0;
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 800;
  color: #2B2420;
  line-height: 1.4;
}
.cr-item-body {
  margin: 0;
  font-size: 14px;
  line-height: 1.9;
  color: #5A4E46;
}
.cr-item-divider {
  margin: 14px 0;
  height: 1px;
  background-image: linear-gradient(to right, #E8C8A3 50%, transparent 50%);
  background-size: 6px 1px;
  background-repeat: repeat-x;
}
.cr-item-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.cr-item-contact {
  font-size: 13px;
  font-weight: 700;
  color: #5A4E46;
}
.cr-item-time {
  font-size: 12px;
  color: #8C7F74;
}
.cr-empty {
  padding: 60px 20px;
  text-align: center;
  color: #8C7F74;
  font-size: 14px;
  background: #fff;
  border-radius: 12px;
  border: 1px dashed #E5D7C4;
}

@media (max-width: 1024px) {
  .cr-body {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .cr-form-card { position: relative; top: 0; }
}

@media (max-width: 820px) {
  .sub-nav { padding: 14px 20px; }
  .cr-head { padding: 64px 16px 48px; }
  .cr-body { padding: 0 16px; }
  .cr-form-inner { padding: 28px 20px 24px; }
  .cr-item { padding: 20px; }
}
</style>
